"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateForBlog = formatDateForBlog;
exports.useToggle = useToggle;
exports.useRefreshable = useRefreshable;
exports.useSet = useSet;
exports.htmlToText = htmlToText;
const react_1 = __importDefault(require("react"));
function formatDateForBlog(date) {
    if (!date) {
        return null;
    }
    const d = new Date(date).toUTCString().split(' ');
    return `${d[2]} ${d[1]}, ${d[3]}`;
}
function useToggle(initialState = false) {
    return react_1.default.useReducer((state, newValue = !state) => newValue, initialState);
}
// Returns [value, refresh]
function useRefreshable(getter) {
    return react_1.default.useReducer(getter, getter());
}
// Each time the Set is updated, the handle is refreshed
// That way, the Set doesn't have to be rebuilt
function useSet(initialValue = []) {
    const { current: set } = react_1.default.useRef(new window.Set(initialValue));
    const [handle, refresh] = useRefreshable(() => ({
        add(newValue) {
            set.add(newValue);
            refresh();
        },
        delete(oldValue) {
            set.delete(oldValue);
            refresh();
        },
        has: (v) => set.has(v),
        values: () => set.values()
    }));
    return handle;
}
function htmlToText(html) {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent;
}
